import { trackSegmentAndGAEvent, EventNames } from '@zoopla/tracking';

export type NavigationLinks = { href: string; title: string }[];

/**
 * @param {boolean} showRemortgage - adds Remortgage link to returned values
 * @returns an array of nav links
 */
export const getNavigationLinks = (showRemortgage = false): NavigationLinks => {
    const navItems = [
        {
            href: '/for-sale/',
            title: 'For sale'
        },
        {
            href: '/to-rent/',
            title: 'To rent'
        },
        {
            href: '/house-prices/',
            title: 'House prices'
        },
        {
            href: '/valuation/',
            title: 'Agent valuation'
        },
        {
            href: '/home-values/',
            title: 'Instant valuation'
        }
    ];

    if (showRemortgage) {
        // insert after house-prices
        navItems.splice(3, 0, {
            href: '/remortgage/',
            title: 'Remortgage'
        });
    }

    return navItems;
};

export const trackAccount = (url: string, label?: string) => () => {
    trackSegmentAndGAEvent(
        EventNames.CLICK_NAV_BAR,
        {
            eventCategory: 'User Account',
            eventAction: 'clickthrough',
            eventLabel:
                label === 'my home'
                    ? 'my home'
                    : label
                    ? `user account>${label}`
                    : 'user account'
        },
        url
    );
};

export const trackNav = (label: string, url: string) => () => {
    trackSegmentAndGAEvent(
        EventNames.CLICK_NAV_BAR,
        {
            eventCategory: 'navbar',
            eventAction: 'clickthrough',
            eventLabel: label.toLowerCase()
        },
        url
    );
};

export const getSigninUrl = (path: string) => {
    const encodedUrl =
        path === '/index-logged-in' ? '%2F' : encodeURIComponent(path);

    return path.includes('/signin/')
        ? '/signin/?with_confirmation=true'
        : `/signin/?page_after_login=${encodedUrl}&return_url=${encodedUrl}&with_confirmation=true`;
};
